export const getSpecsPropertyValue = ({ specifications = [], specificationName }) =>
  (specifications
    .find(spec => spec.specName === specificationName) || {}).specValue
